import { render } from "./fileDropper.vue?vue&type=template&id=4f2f3047&scoped=true&ts=true"
import script from "./fileDropper.vue?vue&type=script&lang=ts"
export * from "./fileDropper.vue?vue&type=script&lang=ts"

import "./fileDropper.vue?vue&type=style&index=0&id=4f2f3047&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2f3047"]])

export default __exports__